import React from 'react';

import { IIconProps, TIconType } from '../interface';

const EyeClosedIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M4.5 3.75L19.5 20.25'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.5215 14.775C13.8333 15.4055 12.9329 15.7536 11.9996 15.75C11.2427 15.7499 10.5036 15.5208 9.87935 15.0928C9.25512 14.6648 8.77502 14.0579 8.50216 13.3519C8.2293 12.6459 8.17646 11.8739 8.35058 11.1373C8.5247 10.4007 8.91764 9.73409 9.47773 9.22501'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.9375 6.43124C3.1125 8.36249 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C13.7574 18.7643 15.4929 18.3594 17.0625 17.5687'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.5564 15.8531C21.6002 14.025 22.5002 12 22.5002 12C22.5002 12 19.5002 5.24999 12.0002 5.24999C11.35 5.24871 10.7008 5.30202 10.0596 5.40937'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.7031 8.31561C13.5006 8.46671 14.2273 8.87311 14.7735 9.47347C15.3198 10.0738 15.6559 10.8356 15.7312 11.6437'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default EyeClosedIcon;
